import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'lib-block-loading',
  imports: [CommonModule, ProgressSpinnerModule, BlockUIModule],
  template: ` @if (!custom && show) {
      <p-blockui [blocked]="show">
        <div class="loading-content">
          <p-progress-spinner></p-progress-spinner>
        </div>
      </p-blockui>
    }
    @if (custom && show) {
      <div class="custom-loading">
        <div class="content">
          <span class="spinner icon progress-spinner"> </span>
          @if (title) {
            <span class="title">{{ title }}</span>
          }
          @if (subTitle) {
            <span class="subTitle">{{ subTitle }}</span>
          }
        </div>
      </div>
    }`,
  styleUrls: ['./block-loading.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockLoadingComponent {
  @Input() show = false;
  @Input() custom = false;
  @Input() title = '';
  @Input() subTitle = '';
}
